import classNames from 'classnames'
import { Button } from 'components/Button/Button'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { useTranslation } from 'react-i18next'
import { MSPCase } from '@cms-max/medicare-api-sdk'
import { MspSummaryCard } from './MspSummaryCard'

type MspCaseResultsProps = {
  classType: 'msa' | 'msp'
  isLoading: boolean
  isError: boolean
  isFinished: boolean
  results: MSPCase[]
  totalCaseResults: number
  onShowMoreSearchResults: () => void
  onShowAllSearchResults: () => void
  className?: string
}

export const MspCaseResults = ({ classType, isLoading, isError, isFinished, results, totalCaseResults, onShowMoreSearchResults, onShowAllSearchResults, className }: MspCaseResultsProps) => {
  const { t } = useTranslation(classType)
  const hasCaseResults = isFinished && results.length > 0
  const noCaseResults = isFinished && results.length === 0
  const showLoadMoreShowMore = (results.length < totalCaseResults) && !isError

  return (
    <section className={classNames(className)}>
      <div className="ds-l-row">
        {!isError && (
          <div className="ds-l-col--12">
            <h2 className="ds-text-heading--2xl ds-u-margin-bottom--1">
              {t('currentSearch.heading')}
            </h2>
            {hasCaseResults && (
              <div aria-live="polite" aria-atomic="true">
                {t('currentSearch.paginationRange', {
                  start: 1,
                  end: results.length,
                  total: totalCaseResults
                })}
              </div>
            )}
            {noCaseResults && (
              <div aria-live="polite" aria-atomic="true">
                {t('currentSearch.noResultsPagination')}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="ds-l-row ds-u-margin-top--4">
        <div className="ds-l-col--12">
          <h3 className="ds-text-heading--xl">{t('paymentSummary')}</h3>
        </div>
      </div>
      <div className="ds-l-row">
        <div className="ds-l-col--12">
          {isLoading && <MySpinner />}
          {noCaseResults && !isError && (
            <div className="my-c-msp--no-results ds-u-margin-top--2">
              {t('caseCard.noResults')}
            </div>
          )}
          {hasCaseResults &&
            !isError &&
            results.map((c) => (
              <MspSummaryCard
                key={c.caseID}
                className="ds-u-margin-top--2"
                caseSummary={c}
                classType={classType}
              />
            ))}
        </div>
      </div>
      {showLoadMoreShowMore && isFinished && (
        <div className='ds-l-row ds-u-margin-top--4'>
          <div className='ds-l-col--12'>
            <Button
              className='ds-c-button ds-c-button--solid ds-c-button--alternate ds-u-margin-right--2'
              onClick={onShowMoreSearchResults}>
                {t('currentSearch.loadMore')}
            </Button>
            <Button
              className='ds-c-button'
              onClick={onShowAllSearchResults}>
                {t('currentSearch.loadAll')}
            </Button>
          </div>
        </div>
      )}
    </section>
  )
}
